import { requestOwnerTypeEnum, requestReplyEnum, stepsEnum } from '@/modules/bankruptcy/helpers/enum';
import router from '@/routes';
import api from '../services/api';
import { initialData } from './state';
import services from '../services/services';

export default {
  getMyMainRequests(store, payload) {
    return api.getMyMainRequests(payload);
  },
  getMyOpenProcedures(store, payload) {
    return api.getMyOpenProcedures(payload);
  },
  getMainApplicantDetails(store, objectKey) {
    return api.getMainApplicantDetails(objectKey);
  },
  getMainRequestInfo(store, objectKey) {
    return api.getMainRequestInfo(objectKey);
  },
  getMyStatistics(store) {
    return api.getMyStatistics();
  },
  updateIsPledged({ commit }, payload) {
    commit('updateIsPledged', payload);
  },
  openRequest({ commit, state, dispatch }, { currentStep, objectKey }) {
    commit('updateCurrentStep', objectKey ? currentStep : initialData().currentStep);
    commit('updateIsPledged', initialData().isPledged);
    commit('resetRequestApplicant');
    commit('resetMainRequest');
    commit('resetRequestDebtorsDetails');
    commit('resetRequestCreditorDetails');
    commit('resetRequestSecretaries');
    commit('resetBankruptActivities');
    commit('resetRequestAttorneyDetails');
    commit('updateSubmittedRequestInfo', initialData().submittedRequestInfo);
    commit('setMainRequestLoading', true);
    if (objectKey) {
      commit('updateMainRequestObjectKey', objectKey);
      commit('updateIsPledged', true);
      api.getMainRequestInfo(objectKey)
        .then((res) => {
          //only debtor should access request details step
          if (res.data.requestOwnerTypeId != requestOwnerTypeEnum.debtor && currentStep == stepsEnum.requestDetails) {
            let url = `/bankruptcy/request/${stepsEnum.requestApplicantData}/${objectKey}`;
            router.push({ path: url });
          }
          commit('updateSubmittedRequestInfo', {
            ...res.data,
            objectKey,
          });
          return res;
        })
        .finally(() => commit('setMainRequestLoading', false));

      api.getMainApplicantDetails(objectKey)
        .then((res) => {
          commit('updateSubmittedApplicantDetails', { ...res.data });
          commit('setRequestAttorneyDetails', {
            attorneyNumber: res.data.attorneyNumber,
            attorneyTypeId: res.data.attorneyTypeId,
            isApprovedFromMofa: res.data.isApprovedFromMofa,
            isApprovedFromMoj: res.data.isApprovedFromMoj,
            externalAttorneySourceId: res.data.externalAttorneySourceId,
            isAttorneyVerified: true,
          });
          return res;
        });

      api.getMainRequestAuditConfirmations(objectKey)
        .then((res) => {
          commit('updateAuditConfirmations', [...res.data]);
          return res;
        });
    } else {
      commit('setMainRequestLoading', false);
      api.getUserInfo()
        .then((res) => {
          const data = {
            identityNumber: res.data.socialId,
            identityTypeId: res.data.socialIdType,
            firstName: res.data.firstName,
            fatherName: res.data.fatherName,
            thirdName: res.data.grandFatherName,
            familyName: res.data.familyName,
            dateOfBirth: res.data.dateOfBirth,
            nationality: res.data.nationalityCountryId,
            gender: res.data.gender,
          };
          commit('updateSubmittedApplicantDetails', data);
          return res;
        });
    }
  },
  getRequestAttachments(_context, requestObjectKey) {
    api.getRequestAttachments(requestObjectKey)
      .then((res) => {
        _context.commit('setAttachments', res.data);
      });

  },
  getBankruptcyRequestAttachments(_context, requestObjectKey) {
    return api.getBankruptcyRequestAttachments(requestObjectKey);
  },
  getRequestAttachmentTypes(_context, requestObjectKey) {
    return api.getRequestAttachmentTypes(requestObjectKey);
  },
  uploadAttachment: async (_context, payload) => {
    const {
      name,
      fileType,
      fileUrl,
      category,
      categoryName,
      fileObject,
      extension,
      typeId = category,
    } = payload.attachment;
    return api
      .uploadAttachment(payload.requestObjectKey, {
        name: name,
        fileType: fileType,
        content: fileUrl.split(',')[1],
        typeId: category,
        extension: extension,
        contentType: fileObject.type,
        requestObjectKey: payload.requestObjectKey,
      }).then((res) => {
        _context.commit('updateAttachments', {
          name,
          typeId,
          category,
          categoryName,
          fileUrl,
          fileObject,
          fileType,
          objectKey: res.data,
        });
      });

  },
  deleteAttachment(_context, payload) {
    return api.deleteAttachment(payload.requestObjectKey, payload.objectKey)
      .then(() => {
        _context.commit('deleteAttachment', payload.objectKey);
      });
  },
  getAttachmentURL(_context, payload) {
    return api
      .getAttachmentURL(payload.requestObjectKey, payload.objectKey)
      .then(res => res.data);
  },
  submitMainRequest(_context, payload) {
    return api
      .submitMainRequest(payload)
      .then(res => res.data);
  },
  updateMainRequest(_context, payload) {
    return api
      .updateMainRequest(payload.objectKey, payload)
      .then(res => res.data);
  },
  getBankruptActivities(_context, requestObjectKey) {
    api.getBankruptActivities(requestObjectKey)
      .then((res) => {
        _context.commit('setBankruptActivities', res.data);
      });
  },
  getActivities(_context, requestObjectKey) {
    return api.getBankruptActivities(requestObjectKey);
  },
  getRequestSecretaries(_context, requestObjectKey) {
    api.getRequestSecretaries(requestObjectKey)
      .then((res) => {
        _context.commit('setRequestSecretaries', res.data);
      });
  },
  getSecretaries(_context, requestObjectKey) {
    return api.getRequestSecretaries(requestObjectKey);
  },
  getRequestDebtorsDetails(_context, requestObjectKey) {
    return api.getRequestDebtorsDetails(requestObjectKey)
      .then((res) => {
        _context.commit('setRequestDebtorsDetails', res.data);
        return res.data;
      });
  },
  getDebtorsDetails(_context, requestObjectKey) {
    return api.getRequestDebtorsDetails(requestObjectKey);
  },
  getRequestCreditorDetails(_context, requestObjectKey) {
    return api.getRequestCreditorDetails(requestObjectKey)
      .then((res) => {
        _context.commit('setRequestCreditorDetails', res.data);
        return res.data;
      });
  },
  getFirmByCommercialRegistrationNumber(_context, payload) {
    return api.getFirmByCommercialRegistrationNumber(payload);
  },
  getCreditorDetails(_context, requestObjectKey) {
    return api.getRequestCreditorDetails(requestObjectKey);
  },
  submitMainRequestDetails(_context, payload) {
    return api
      .submitMainRequestDetails(payload.objectKey, payload)
      .then(res => res.data);
  },
  sendRequest(_context, payload) {
    var request;
    if (payload.action === requestReplyEnum.submitNewRequest)
      request = api.sendRequest(payload.objectKey);
    if (payload.action === requestReplyEnum.completeRequest)
      request = api.completeRequest(payload.objectKey);
    return !request ? null : request.then(res => res.data);
  },
  getIncompleteReasons(_context, requestObjectKey) {
    return api.getIncompleteReasons(requestObjectKey)
      .then((res) => {
        _context.commit('updateReplies', res.data);
        return res.data;
      });
  },
  getSessionsByRequestObjectKey(_context, requestObjectKey) {
    return api.getSessionsByRequestObjectKey(requestObjectKey);
  },
  getJudgementsByRequestObjectKey(_context, requestObjectKey) {
    return api.getJudgementsByRequestObjectKey(requestObjectKey);
  },
  getSubRequestsByRequestObjectKey(_context, requestObjectKey) {
    return api.getSubRequestsByRequestObjectKey(requestObjectKey);
  },
  getDecisionsByRequestObjectKey(_context, requestObjectKey) {
    return api.getDecisionsByRequestObjectKey(requestObjectKey);
  },
  getProceduresByRequestObjectKey(_context, requestObjectKey) {
    return api.getProceduresByRequestObjectKey(requestObjectKey);
  },
  getMainRequestSecretariesApproved(_context, requestObjectKey) {
    return api.getMainRequestSecretariesApproved(requestObjectKey);
  },
  getMySubRequests(store, payload) {
    return api.getMySubRequests(payload);
  },
  mainRequestInquiry(store, payload) {
    return api.mainRequestInquiry(payload);
  },
  subRequestInquiry(store, payload) {
    return api.subRequestInquiry(payload);
  },
  getMainRequestJudgementsSummary(_context, requestObjectKey) {
    return api.getMainRequestJudgementsSummary(requestObjectKey);
  },
  getMainRequestParties(_context, requestObjectKey) {
    return api.getMainRequestParties(requestObjectKey);
  },
  saveRelatedRequest(store, payload) {
    return api.saveRelatedRequest(payload);
  },
  validateRelatedRequest(store, payload) {
    return services.validateRelatedRequest(payload);
  },
  getRelatedRequest(store, objectKey) {
    return api.getRelatedRequest(objectKey);
  },
  updateRelatedRequest(store, payload) {
    return api.updateRelatedRequest(payload);
  },
  canIssueSubRequest(store, payload) {
    return api.canIssueSubRequest(payload);
  },
  inquiryMainRequestPartner(_context, payload) {
    return api.inquiryMainRequestPartner(payload);
  },
  inquiryMainRequestCreditor(_context, payload) {
    return api.inquiryMainRequestCreditor(payload);
  },
  inquiryMainRequestDebtorEmployees(_context, payload) {
    return api.inquiryMainRequestDebtorEmployees(payload);
  },
  inquiryMainRequestInterestParty(_context, payload) {
    return api.inquiryMainRequestInterestParty(payload);
  },
  getManagerIdentityInquiry(_context, payload) {
    return api.getManagerIdentityInquiry(payload);
  },
  checkHasAccessToMainRequest(_context, requestObjectKey) {
    return api.checkHasAccessToMainRequest(requestObjectKey);
  },
  checkHasAccessToSubRequest(_context, requestObjectKey) {
    return api.checkHasAccessToSubRequest(requestObjectKey);
  },
  getSessionsBySubRequestObjectKey(_context, requestObjectKey) {
    return api.getSessionsBySubRequestObjectKey(requestObjectKey);
  },
  getParentSessionsBySubRequestObjectKey(_context, requestObjectKey) {
    return api.getParentSessionsBySubRequestObjectKey(requestObjectKey);
  },
  getRequestsBySubRequestObjectKey(_context, requestObjectKey) {
    return api.getRequestsBySubRequestObjectKey(requestObjectKey);
  },
  getJudgementsBySubRequestObjectKey(_context, requestObjectKey) {
    return api.getJudgementsBySubRequestObjectKey(requestObjectKey);
  },
  getParentJudgementsBySubRequestObjectKey(_context, requestObjectKey) {
    return api.getParentJudgementsBySubRequestObjectKey(requestObjectKey);
  },
  getDecisionsBySubRequestObjectKey(_context, requestObjectKey) {
    return api.getDecisionsBySubRequestObjectKey(requestObjectKey);
  },
  getAttachmentsBySubRequestObjectKey(_context, requestObjectKey) {
    return api.getAttachmentsBySubRequestObjectKey(requestObjectKey);
  },
  getValidSubRequestsTypes(_context) {
    return api.getValidSubRequestsTypes();
  },
  getValidSubRequestsForProcedure(_context, payload) {
    return api.getValidSubRequestsForProcedure(payload);
  },
  getSubRequestType(_context, requestCode) {
    return api.getSubRequestType(requestCode);
  },
  getMainRequestDeposits(_context, requestCode) {
    return api.getMainRequestDeposits(requestCode);
  },
  getSubRequestDeposits(_context, requestCode) {
    return api.getSubRequestDeposits(requestCode);
  },
  getSubRequestDecisionsAttachments(_context, requestCode) {
    return api.getSubRequestDecisionsAttachments(requestCode);
  },

  saveReplyMemo(_context, payload) {
    return api.saveReplyMemo(payload);
  },

  getMainRequestReplyMemos(_context, mainRequestObjectKey) {
    return api.getMainRequestReplyMemos(mainRequestObjectKey);
  },

  getReplyMemo(_context, payload) {
    return api.getReplyMemo(payload.mainRequestObjectKey, payload.replyMemoObjectKey);
  },

  canIssueReplyMemo(_context, mainRequestObjectKey) {
    return api.canIssueReplyMemo(mainRequestObjectKey);
  },

  getBankruptcyUserInfo(_context) {
    Promise.all([api.getUserInfo(), api.getDashboardUserInfo()])
      .then((res) => {
        const user = res[0].data;
        const dashboardUser = res[1].data;
        user['loginType'] = dashboardUser['loginType'];
        _context.commit('setCurrentUserInfo', user);
      });
  },
  getMainRequestOrganizationPartyInfo(_context, payload) {
    return api.getMainRequestOrganizationPartyInfo(payload.objectKey, payload.unifiedNumber, payload.crNumber);
  },
  getSubRequestsTypesByCategory(_context, payload, categoryObjectKey) {
    return api.getSubRequestsTypesByCategory(payload, categoryObjectKey);
  },
  getSubRequestsTypesCategories(_context, payload) {
    return api.getSubRequestsTypesCategories(payload);
  },
  getELitigationSessionsByRequestObjectKey(_context, requestObjectKey) {
    return api.getELitigationSessionsByRequestObjectKey(requestObjectKey);

  },
  getELitigationSessionsBySubRequestObjectKey(_context, requestObjectKey) {
    return api.getELitigationSessionsBySubRequestObjectKey(requestObjectKey);

  },
  checkCanAccessElitigationSessions(_context, requestObjectKey) {
    return api.checkCanAccessElitigationSessions(requestObjectKey);

  },
  checkCanAccessSubRequestElitigationSessions(_context, requestObjectKey) {
    return api.checkCanAccessSubRequestElitigationSessions(requestObjectKey);

  },
  getELitigationSessionQuestionsAndAnswers(_context, sessionObjectKey) {
    return api.getELitigationSessionQuestionsAndAnswers(sessionObjectKey);

  },
  sendAnswerForElitigationQuestion(_context, payload) {
    return api
      .sendAnswerForElitigationQuestion(payload)
      .then(res => res.data);
  },
  canIssueSubRequestMemo(_context, payload) {
    return api.canIssueSubRequestMemo(payload);
  },
  getSubRequestMemos(_context, payload) {
    return api.getSubRequestMemos(payload);
  },
  getOwnSubRequestMemo(_context, payload) {
    return api.getOwnSubRequestMemo(payload);
  },
  getSubRequestMemosReplies(_context, payload) {
    return api.getSubRequestMemosReplies(payload);
  },
  submitSubRequestMemo(_context, payload) {
    const { text, parentMemoObjectKey, subRequestObjectKey, attachments } = payload;
    const body = { text };
    if (parentMemoObjectKey) {
      body.parentMemoObjectKey = parentMemoObjectKey;
    }
    if (attachments && attachments.length > 0) {
      body.attachments = attachments;
    }
    return api.submitSubRequestMemo(subRequestObjectKey, body);
  },
  submitSubRequestMemoReply(_context, payload) {
    const { text, memoObjectKey, parentMemoObjectKey, attachments } = payload;
    const body = parentMemoObjectKey ? { text, parentMemoObjectKey } : { text };
    if (attachments && attachments.length > 0) {
      body.attachments = attachments;
    }
    return api.submitSubRequestMemoReply(memoObjectKey, body);
  },
  canReplyToSubRequestMemo(_context, payload) {
    return api.canReplyToSubRequestMemo(payload);
  },
};
